export default __webpack_public_path__ + "static/media/logo3.37d749fb.jpg";